module.exports = {"apiUrl":"/api"}


//////////////////
// WEBPACK FOOTER
// ./app/app-config.json
// module id = 22
// module chunks = 0